import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import {
  ShiftTimelineDataStateModel,
  ShiftTimelineFilterStateModel,
  ShiftTimelineInteractionsModel,
  TimelineModalFilterStateModel,
} from './interfaces';
import { ShiftTimelineDataState } from './shift-timeline-data/shift-timeline-data.state';
import { ShiftTimelineFilterUnassignedRegionState } from './shift-timeline-filter-unassigned-region/shift-timeline-filter-unassigned-region.state';
import { ShiftTimelineFiltersState } from './shift-timeline-filters/shift-timeline-filters.state';
import { ShiftTimelineInteractionsState } from './shift-timeline-interactions/shift-timeline-interactions.state';
import { ShiftTimelineSettingsState } from './shift-timeline-settings/shift-timeline-settings.state';
import { ShiftTimelineUnassignedRegionState } from './shift-timeline-unassigned-region/shift-timeline-unassigned-region.state';
import { TimelineModalFilterState } from './timeline-modal-filters/timeline-modal-filters.state';

export interface ShiftTimelineStateModel {
  shiftTimelineData: ShiftTimelineDataStateModel;
  shiftTimelineFilter: ShiftTimelineFilterStateModel;
  shiftTimelineInteractions: ShiftTimelineInteractionsModel;
  timelineModalFilterState: TimelineModalFilterStateModel;
}
@State({
  name: 'shiftTimeline',
  children: [
    ShiftTimelineDataState,
    ShiftTimelineFiltersState,
    ShiftTimelineInteractionsState,
    ShiftTimelineUnassignedRegionState,
    ShiftTimelineFilterUnassignedRegionState,
    TimelineModalFilterState,
  ],
})
@Injectable()
export class ShiftTimelineState {
  @Selector([
    ShiftTimelineSettingsState.pixelWidthPerDay(),
    ShiftTimelineDataState.daysRangeCount,
  ])
  static frameLength(pixelWidthPerDay: number, dayCount: number): number {
    return dayCount * pixelWidthPerDay;
  }
}
